import { useDispatch, useSelector } from "react-redux";
import { TvmFormSubmitResult } from "../../components/common/tvm-form/form-definition";
import {
	create,
	get,
	loadForm,
	loadFormResult,
	reset,
	submitFormResult,
	update,
} from "./actions";
import {
	getCreatedSystemId,
	getCreateReqInfo,
	getCurrentForm,
	getCurrentFormReqInfo,
	getFormResult,
	getFormResultReqInfo,
	getSubmitFormFields,
	getSubmitFormFlags,
	getSubmitFormResult,
	getSubmitFormResultReqInfo,
	getSystem,
	getSystemReqInfo,
	getUpdatedSystemId,
	getUpdateReqInfo,
} from "./selectors";

export function useSystem() {
	const dispatch = useDispatch();

	return {
		create: (name, length, power) => dispatch(create(name, length, power)),
		update: (id, patch) => dispatch(update(id, patch)),
		get: (id) => dispatch(get(id)),
		reset: () => dispatch(reset()),
		loadForm: (formId) => dispatch(loadForm(formId)),
		loadFormResult: <T>(systemId, formId) =>
			dispatch(loadFormResult<T>(systemId, formId)),
		submitFormResult: <T>(
			systemId,
			formId,
			fieldValues: TvmFormSubmitResult<T>
		) => dispatch(submitFormResult(systemId, formId, fieldValues)),

		createdSystemId: useSelector(getCreatedSystemId),
		createReqInfo: useSelector(getCreateReqInfo),
		updatedSystemId: useSelector(getUpdatedSystemId),
		updateReqInfo: useSelector(getUpdateReqInfo),
		system: useSelector(getSystem),
		systemReqInfo: useSelector(getSystemReqInfo),
		currentForm: useSelector(getCurrentForm),
		currentFormValues: useSelector(getFormResult),
		currentFormReqInfo: useSelector(getCurrentFormReqInfo),
		formResult: useSelector(getSubmitFormResult),
		formFlags: useSelector(getSubmitFormFlags),
		formFields: useSelector(getSubmitFormFields),
		formResultReqInfo: useSelector(getFormResultReqInfo),
		submitFormResultReqInfo: useSelector(getSubmitFormResultReqInfo),
	};
}
